<template>
  <div class="merchant-Feed">
    <GlobalInfoBar title="投诉管理" content="线上用户投诉信息" />
    <GlobalChunk icon="search" title="筛选查询" :padding="[20, 20, 20, 20]">

      <div slot="filter">
        <Form @changeNav="changeNavFrom"></Form>
      </div>
      <GlobalNav :navList="[
        { id: '', name: '全部', numKey: 'index' },
        { id: '01', name: '未处理', numKey: 'index2', isRed: true },
        { id: '02', name: '已处理', numKey: 'index3' },
      ]" :initNav="{ id: '', name: '全部', numKey: 'index' }"
        :numList="{ index: totalIndex, index2: totalIndex2, index3: totalIndex3 }" @changeNav="changeNav"
        style="margin-bottom: 21px;" />

      <Table :tableData="tableDataIndex" :Feedtotal="Feedtotal" :FeedpageNum="FeedpageNum"
        @handleCurrentChange="handleCurrentChange"></Table>
    </GlobalChunk>
  </div>
</template>

<script>
import Form from "./Form"
import Table from "./Table"
import _api from "@/utils/request";
import { http } from "../../../utils/request/newIndex"
export default {
  name: 'merchant-Feed',
  components: { Form, Table },

  data() {
    return {
      tableDataIndex: [],
      totalIndex: "",
      totalIndex2: "",
      totalIndex3: "",
      state: "",
      named: "",
      complaintTarget: "",
      entryTime: "",
      storeId:"",
      Feedtotal: 0,
      FeedpageNum: 1,
      FeedpageSize: 10,
    }
  },
  created() {
    // this.FeedDataList()
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.FeedpageNum = val
      this.FeedDataList()
    },
    //查询
    changeNavFrom(val) {
      const SeachParams = {
        named: val.named,
        complaintRecycleType: val.complaintTarget,
        startTime: val.startTime,
        endTime: val.endTime,
        state: "00",
        storeId:val.id,
        pageNum: 1,
        pageSize: 10,
      }
      http.getComplaint(SeachParams).then(res => {
        if (res.code === 1) {
          this.tableDataIndex = res.data.page.records
          this.Feedtotal = res.data.page.total
          this.FeedpageNum = 1
          this.totalIndex = res.data.allCount
          this.totalIndex2 = res.data.untreated
          this.totalIndex3 = res.data.processed
        }
        if (typeof val.disuseLoding === 'function') {
          val.disuseLoding();
        }
      }).catch(() => {
        if (typeof val.disuseLoding === 'function') {
          val.disuseLoding();
        }
      });
    },
    //tab页
    changeNav(val) {
      this.state = val.id
      this.FeedpageNum = 1
      console.log(val)
      this.FeedDataList()
    },
    //列表请求
    FeedDataList() {
      let data = {
        "complaintRecycleType": this.complaintTarget,
        "miniShoppingMallId": null,
        "named": this.named,
        "pageNum": this.FeedpageNum,
        "pageSize": this.FeedpageSize,
        "state": this.state,
        'startTime': this.startTime,
        "endTime": this.endTime,
        "storeId": this.storeId
      }
      http.getComplaint(data).then(res => {
        if (res.code === 1) {
          this.tableDataIndex = res.data.page.records
          this.Feedtotal = res.data.page.total
          this.totalIndex = res.data.allCount
          this.totalIndex2 = res.data.untreated
          this.totalIndex3 = res.data.processed
        }
      })
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-Feed {}
</style>
